import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "EditEnrolment" }
const _hoisted_2 = { class: "DrawerHeader" }
const _hoisted_3 = { class: "DrawerControls" }
const _hoisted_4 = {
  key: 0,
  class: "ClientSyncMessage"
}
const _hoisted_5 = { class: "ExitButton DrawerCancelButton" }
const _hoisted_6 = {
  key: 0,
  class: "ColumnContainer"
}
const _hoisted_7 = { class: "Column" }
const _hoisted_8 = { class: "GroupWrapper" }
const _hoisted_9 = { class: "ElementWrapper" }
const _hoisted_10 = {
  key: 0,
  class: "EnrolmentStatusLabel"
}
const _hoisted_11 = {
  key: 1,
  class: "EnrolmentStatusLabel EnrolmentStatus"
}
const _hoisted_12 = { class: "ElementWrapper" }
const _hoisted_13 = { class: "ElementValue" }
const _hoisted_14 = { class: "GroupWrapper" }
const _hoisted_15 = { class: "ElementWrapper" }
const _hoisted_16 = { class: "ElementValue" }
const _hoisted_17 = { class: "FgElementWrapper" }
const _hoisted_18 = { class: "ElementWrapper" }
const _hoisted_19 = { class: "ElementValue" }
const _hoisted_20 = { class: "ElementWrapper" }
const _hoisted_21 = { class: "ElementWrapper" }
const _hoisted_22 = { class: "FgElementWrapper" }
const _hoisted_23 = ["href"]
const _hoisted_24 = {
  key: 1,
  class: "lnr-linkedin DisabledSocialMediaLink"
}
const _hoisted_25 = { class: "FgElementWrapper" }
const _hoisted_26 = ["href"]
const _hoisted_27 = {
  key: 1,
  class: "lnr-facebook DisabledSocialMediaLink"
}
const _hoisted_28 = { class: "ElementWrapper" }
const _hoisted_29 = { class: "ElementValue" }
const _hoisted_30 = { class: "ElementWrapper" }
const _hoisted_31 = {
  key: 0,
  class: "ElementValue"
}
const _hoisted_32 = {
  key: 1,
  class: "ElementValue"
}
const _hoisted_33 = { class: "ElementWrapper" }
const _hoisted_34 = {
  key: 0,
  class: "ElementValue"
}
const _hoisted_35 = {
  key: 1,
  class: "ElementValue"
}
const _hoisted_36 = { class: "Column" }
const _hoisted_37 = { class: "GroupWrapper" }
const _hoisted_38 = { class: "ElementWrapper" }
const _hoisted_39 = { class: "ElementValue" }
const _hoisted_40 = { class: "ElementWrapper" }
const _hoisted_41 = { class: "ElementValue" }
const _hoisted_42 = { class: "FgElementWrapper" }
const _hoisted_43 = { class: "ElementWrapper" }
const _hoisted_44 = { class: "FgElementWrapper" }
const _hoisted_45 = { class: "ElementWrapper" }
const _hoisted_46 = { class: "GroupWrapper" }
const _hoisted_47 = { class: "ElementWrapper" }
const _hoisted_48 = { class: "FgElementWrapper" }
const _hoisted_49 = { class: "ElementWrapper" }
const _hoisted_50 = { class: "Label" }
const _hoisted_51 = { class: "ElementWrapper" }
const _hoisted_52 = { class: "ElementValue" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Drawer = _resolveComponent("Drawer")!
  const _component_SuspectedDuplicateDetailsModal = _resolveComponent("SuspectedDuplicateDetailsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Drawer, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[11] || (_cache[11] = _createElementVNode("h4", { class: "DrawerTitle" }, "Edit Enrolment", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.enrolment && _ctx.enrolment.isSharedWithClient())
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("i", { class: "lnr-notification-circle ClientSyncIcon" }, null, -1 /* CACHED */),
                  _createTextVNode(" Your changes will be seen by the client ", -1 /* CACHED */)
                ]))]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("button", {
              class: "DriverButton",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, "Save"),
            _createElementVNode("button", _hoisted_5, [
              _createElementVNode("i", {
                class: "lnr-cross CancelIcon",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
              })
            ])
          ])
        ]),
        _createElementVNode("form", {
          id: "EditForm",
          class: "FgForm",
          name: "EditForm",
          novalidate: "",
          autocomplete: "off",
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
        }, [
          (null !== _ctx.enrolment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[13] || (_cache[13] = _createElementVNode("h2", null, "Enrolment status", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_9, [
                      (_ctx.enrolment.fulfillmentStep.name.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.enrolment.fulfillmentStep.name), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (_ctx.enrolment.status.name.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.enrolment.status.name), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (_ctx.stepIsDuplicateSuspected)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "Textlink ShowSuspectedDuplicatesButton",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showSuspectedDuplicates && _ctx.showSuspectedDuplicates(...args)))
                          }, " Show duplicates "))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", { class: "LabelNonEditable" }, "Invoice batch ID", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.enrolment.invoicingBatchIdentity || '-'), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[26] || (_cache[26] = _createElementVNode("h2", null, "Student information", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[14] || (_cache[14] = _createElementVNode("label", { class: "LabelNonEditable" }, "Email", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.enrolment.studentEmail), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _withDirectives(_createElementVNode("input", {
                        id: "StudentName",
                        class: _normalizeClass(["FgInput js-Input", { HasValue: '' != _ctx.enrichmentSpecification.studentName }]),
                        type: "text",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.enrichmentSpecification.studentName) = $event))
                      }, null, 2 /* CLASS */), [
                        [_vModelText, _ctx.enrichmentSpecification.studentName]
                      ]),
                      _cache[15] || (_cache[15] = _createElementVNode("label", {
                        class: "FgLabel",
                        for: "StudentName"
                      }, "Student name", -1 /* CACHED */))
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[16] || (_cache[16] = _createElementVNode("label", { class: "LabelNonEditable" }, "Client identification number", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.enrolment.studentOrganisationRegistrationNumber || '-'), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[17] || (_cache[17] = _createElementVNode("label", { class: "LabelNonEditable" }, "Student nationality", -1 /* CACHED */)),
                      _createVNode(_component_MultiSelect, {
                        ref: "nationalityDropdown",
                        label: "Nothing selected",
                        placeholder: "Nothing selected",
                        options: _ctx.countriesAsOptions,
                        searchable: true,
                        entity: "country",
                        onUpdated: _ctx.setStudentNationality
                      }, null, 8 /* PROPS */, ["options", "onUpdated"])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _cache[18] || (_cache[18] = _createElementVNode("label", { class: "LabelNonEditable" }, "Country of residence", -1 /* CACHED */)),
                      _createVNode(_component_MultiSelect, {
                        ref: "residenceDropdown",
                        label: "Nothing selected",
                        placeholder: "Nothing selected",
                        options: _ctx.countriesAsOptions,
                        searchable: true,
                        entity: "country",
                        onUpdated: _ctx.setStudentCountryOfResidence
                      }, null, 8 /* PROPS */, ["options", "onUpdated"])
                    ]),
                    _cache[27] || (_cache[27] = _createElementVNode("h3", { class: "LabelNonEditable" }, "Online profile", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        id: "studentLinkedIn",
                        class: _normalizeClass(["FgInput SocialMediaInput js-Input", { HasValue: '' != _ctx.enrichmentSpecification.studentLinkedIn }]),
                        type: "text",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.enrichmentSpecification.studentLinkedIn) = $event))
                      }, null, 2 /* CLASS */), [
                        [_vModelText, _ctx.enrichmentSpecification.studentLinkedIn]
                      ]),
                      _cache[20] || (_cache[20] = _createElementVNode("label", {
                        class: "FgLabel",
                        for: "studentLinkedIn"
                      }, "LinkedIn", -1 /* CACHED */)),
                      (_ctx.isLinkedInLinkAvailable())
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: _ctx.enrichmentSpecification.studentLinkedIn,
                            class: "SocialMediaLink",
                            target: "linkedin"
                          }, [...(_cache[19] || (_cache[19] = [
                            _createElementVNode("i", { class: "lnr-linkedin" }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_23))
                        : (_openBlock(), _createElementBlock("i", _hoisted_24))
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _withDirectives(_createElementVNode("input", {
                        id: "studentFacebook",
                        class: _normalizeClass(["FgInput SocialMediaInput js-Input", { HasValue: '' != _ctx.enrichmentSpecification.studentFacebook }]),
                        type: "text",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.enrichmentSpecification.studentFacebook) = $event))
                      }, null, 2 /* CLASS */), [
                        [_vModelText, _ctx.enrichmentSpecification.studentFacebook]
                      ]),
                      _cache[22] || (_cache[22] = _createElementVNode("label", {
                        class: "FgLabel",
                        for: "studentFacebook"
                      }, "Facebook", -1 /* CACHED */)),
                      (_ctx.isFacebookLinkAvailable())
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: _ctx.enrichmentSpecification.studentFacebook,
                            class: "SocialMediaLink",
                            target: "facebook"
                          }, [...(_cache[21] || (_cache[21] = [
                            _createElementVNode("i", { class: "lnr-facebook" }, null, -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_26))
                        : (_openBlock(), _createElementBlock("i", _hoisted_27))
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", {
                        class: "LabelNonEditable",
                        for: "ExampleId"
                      }, "Registration date", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.formatDate(_ctx.enrolment.studentRegistrationDate)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _cache[24] || (_cache[24] = _createElementVNode("label", {
                        class: "LabelNonEditable",
                        for: "ExampleId"
                      }, "First active date", -1 /* CACHED */)),
                      (_ctx.enrolment.studentFirstActiveDate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.formatDate(_ctx.enrolment.studentFirstActiveDate)), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("span", _hoisted_32, "-"))
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _cache[25] || (_cache[25] = _createElementVNode("label", {
                        class: "LabelNonEditable",
                        for: "ExampleId"
                      }, "Last active date", -1 /* CACHED */)),
                      (_ctx.enrolment.studentLastActiveDate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.formatDate(_ctx.enrolment.studentLastActiveDate)), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("span", _hoisted_35, "-"))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _cache[35] || (_cache[35] = _createElementVNode("h2", null, "Programme & university", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_38, [
                      _cache[28] || (_cache[28] = _createElementVNode("label", {
                        class: "LabelNonEditable",
                        for: "ExampleId"
                      }, "University ID", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.enrolment.organisationIdentity), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _cache[29] || (_cache[29] = _createElementVNode("label", {
                        class: "LabelNonEditable",
                        for: "ExampleId"
                      }, "University", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.enrolment.organisationName), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _withDirectives(_createElementVNode("input", {
                        id: "programmeName",
                        class: _normalizeClass(["FgInput js-Input", { HasValue: _ctx.enrichmentSpecification.programmeName !== '' }]),
                        type: "text",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.enrichmentSpecification.programmeName) = $event))
                      }, null, 2 /* CLASS */), [
                        [_vModelText, _ctx.enrichmentSpecification.programmeName]
                      ]),
                      _cache[30] || (_cache[30] = _createElementVNode("label", {
                        class: "FgLabel",
                        for: "programmeName"
                      }, "Programme", -1 /* CACHED */))
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _cache[31] || (_cache[31] = _createElementVNode("label", { class: "LabelNonEditable" }, "Degree", -1 /* CACHED */)),
                      _createVNode(_component_MultiSelect, {
                        ref: "levelDropdown",
                        label: "Nothing selected",
                        placeholder: "Nothing selected",
                        options: _ctx.programmeLevelsAsOptions,
                        searchable: true,
                        entity: "programme level",
                        onUpdated: _ctx.setProgrammeLevel
                      }, null, 8 /* PROPS */, ["options", "onUpdated"])
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _withDirectives(_createElementVNode("input", {
                        id: "tuitionFee",
                        class: _normalizeClass(["FgInput js-Input", {
										HasValue: _ctx.enrichmentSpecification.tuitionFee !== undefined,
										HasError: !_ctx.isTuitionFeeValid
									}]),
                        type: "number",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.enrichmentSpecification.tuitionFee) = $event))
                      }, null, 2 /* CLASS */), [
                        [_vModelText, _ctx.enrichmentSpecification.tuitionFee]
                      ]),
                      _cache[32] || (_cache[32] = _createElementVNode("label", {
                        class: "FgLabel",
                        for: "tuitionFee"
                      }, "Tuition fee", -1 /* CACHED */)),
                      _cache[33] || (_cache[33] = _createElementVNode("div", { class: "FgMessageContainer" }, [
                        _createElementVNode("span", { class: "FgMessage ErrorMessage" }, "Please specify the tuition fee")
                      ], -1 /* CACHED */))
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _cache[34] || (_cache[34] = _createElementVNode("label", { class: "LabelNonEditable" }, "Currency", -1 /* CACHED */)),
                      _createVNode(_component_MultiSelect, {
                        ref: "currencyDropdown",
                        label: "Nothing selected",
                        placeholder: "Nothing selected",
                        options: _ctx.currenciesAsOptions,
                        searchable: true,
                        entity: "currency",
                        validationLabel: "Please specify the currency",
                        valid: _ctx.isTuitionFeeCurrencyValid,
                        onUpdated: _ctx.setTuitionFeeCurrency
                      }, null, 8 /* PROPS */, ["options", "valid", "onUpdated"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _cache[40] || (_cache[40] = _createElementVNode("h2", null, "Enrolment details", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_47, [
                      _cache[36] || (_cache[36] = _createElementVNode("label", { class: "LabelNonEditable" }, "Intake month", -1 /* CACHED */)),
                      _createVNode(_component_MultiSelect, {
                        ref: "monthDropdown",
                        label: "Nothing selected",
                        placeholder: "Nothing selected",
                        options: _ctx.monthsAsOptions,
                        searchable: true,
                        entity: "month",
                        onUpdated: _ctx.setIntakeMonth
                      }, null, 8 /* PROPS */, ["options", "onUpdated"])
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _withDirectives(_createElementVNode("input", {
                        id: "intakeYear",
                        class: _normalizeClass(["FgInput Inline js-Input", { HasValue: '' != _ctx.enrichmentSpecification.intakeYear }]),
                        type: "number",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.enrichmentSpecification.intakeYear) = $event))
                      }, null, 2 /* CLASS */), [
                        [_vModelText, _ctx.enrichmentSpecification.intakeYear]
                      ]),
                      _cache[37] || (_cache[37] = _createElementVNode("label", {
                        class: "FgLabel",
                        for: "intakeYear"
                      }, "Intake year", -1 /* CACHED */))
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _cache[38] || (_cache[38] = _createElementVNode("label", {
                        class: "LabelNonEditable",
                        for: "ExampleId"
                      }, "Identification source", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.enrolment.internalSourceName), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _cache[39] || (_cache[39] = _createElementVNode("label", {
                        class: "LabelNonEditable",
                        for: "ExampleId"
                      }, "PSM owner", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.enrolment.psmOwner), 1 /* TEXT */)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ], 32 /* NEED_HYDRATION */)
      ]),
      _: 1 /* STABLE */
    }),
    (_ctx.suspectedDuplicateDetailsModalShown)
      ? (_openBlock(), _createBlock(_component_SuspectedDuplicateDetailsModal, { key: 0 }))
      : _createCommentVNode("v-if", true)
  ]))
}